import { ArrowRight } from "lucide-react";
import { portalUrl } from "../data";

const items = [
  { title: "Carteira completa", desc: "Todos os seus títulos em um só lugar." },
  { title: "Saldo devedor", desc: "Quanto ainda está em aberto." },
  { title: "Valores de cada operação", desc: "O detalhe de cada título antecipado." },
];

// Destaque logo após o topo: o cliente acompanha a própria carteira no portal
export default function Portfolio() {
  return (
    <section className="sec" aria-labelledby="carteira-titulo">
      <div className="wrap">
        <div className="portfolio" data-reveal>
          <div className="portfolio-head">
            <h2 className="h2" id="carteira-titulo">
              Acesso total à sua carteira
            </h2>
            <p className="lead">
              Pelo portal do cliente, você acompanha toda a sua operação.
            </p>
            <a href={portalUrl} className="btn btn-on-dark">
              Acessar o portal
              <ArrowRight size={18} aria-hidden="true" />
            </a>
          </div>
          <ul className="portfolio-list">
            {items.map((item) => (
              <li key={item.title}>
                <strong>{item.title}</strong>
                <span>{item.desc}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
